import React from "react"
import {ManagedSolutionsAccount} from "../../../resources/managedSolutions"
import Card from "../../../containers/Card/Card"
import {useIsOrgUser} from "../../../services/auth"
import Icon from "../../Icon/Icon"
import {LinkArrowIcon} from "../../LinkArrowIcon/LinkArrowIcon"
import {useNavigate} from "react-router-dom"
import numeral from "numeral"

function getAccountIdString(isOrgUser: boolean, accountId: string) {
	return !isOrgUser ? `#${accountId}` : undefined
}

export function OrgAccountCard({accounts}: {accounts: ManagedSolutionsAccount[]}) {
	const isOrgUser = useIsOrgUser()
	const navigate = useNavigate()

	if (accounts.length === 0) {
		return null
	}

	return (
		<Card title={"Org Account"} icon={"money-note-1--business-products"} className="org-accounts-summary-container">
			<div className="org-accounts-summary">
				{accounts.map((account) => {
					const accountId = account.id
					const balance = account.attributes.balance

					return (
						<div
							key={accountId}
							className="account-box operational-account"
							onClick={(e) => {
								e.preventDefault()
								navigate(`/managed-solutions/accounts/${accountId}`)
							}}
							style={{cursor: "pointer"}}
						>
							<div className="account-box-title-container">
								<Icon icon="wallet--business-products" size={20} />
								<span>Operational Account</span>
								{getAccountIdString(isOrgUser, accountId) && (
									<span className="account-box-additional-title">{getAccountIdString(isOrgUser, accountId)}</span>
								)}
							</div>
							<div className="account-box-data-container">
								<span className="account-box-data-amount">
									{balance !== undefined ? numeral(balance / 100).format("$0,0.00") : "—"}
								</span>
							</div>
							<div className="account-box-arrow-icon-container">
								<LinkArrowIcon />
							</div>
						</div>
					)
				})}
			</div>
		</Card>
	)
}
